import { createTheme } from 'styled-breakpoints';

export const breakpoints = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

export const breakpointTheme = createTheme(breakpoints);
